import { refs } from '../../core/refs.js';

let activeMenu = null;

const MENU_EDGE_GAP = 8;

function setMobileContextExpanded(expanded) {
  if (refs.mobileContextFab) {
    refs.mobileContextFab.setAttribute('aria-expanded', String(expanded));
  }
}

function positionMenu(menu, x, y) {
  const rect = menu.getBoundingClientRect();
  const menuWidth = rect.width || 180;
  const menuHeight = rect.height || 160;
  const maxX = Math.max(MENU_EDGE_GAP, window.innerWidth - menuWidth - MENU_EDGE_GAP);
  const maxY = Math.max(MENU_EDGE_GAP, window.innerHeight - menuHeight - MENU_EDGE_GAP);

  menu.style.left = `${Math.min(Math.max(MENU_EDGE_GAP, x), maxX)}px`;
  menu.style.top = `${Math.min(Math.max(MENU_EDGE_GAP, y), maxY)}px`;
}

export function createMenu() {
  const menu = document.createElement('div');
  menu.className = 'custom-context-menu context-menu';
  menu.setAttribute('role', 'menu');
  return menu;
}

export function showMenu(menu, x, y) {
  document.body.appendChild(menu);
  activeMenu = menu;
  positionMenu(menu, x, y);
  setMobileContextExpanded(true);
}

export function addDivider(menu) {
  const divider = document.createElement('div');
  divider.className = 'menu-divider';
  divider.setAttribute('role', 'separator');
  menu.appendChild(divider);
}

export function addMenuItem(menu, { className, label, action, disabled = false, active = false, shortcut = '' }) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = `menu-item ${className}`;
  button.setAttribute('role', 'menuitem');
  button.disabled = disabled;
  if (active) {
    button.classList.add('active');
    button.setAttribute('aria-pressed', 'true');
  }
  if (disabled) {
    button.setAttribute('aria-disabled', 'true');
  }
  if (shortcut) {
    button.setAttribute('aria-keyshortcuts', shortcut);
    button.setAttribute('title', `${label} (${shortcut})`);
  }

  const labelEl = document.createElement('span');
  labelEl.className = 'menu-item-label';
  labelEl.textContent = label;
  button.appendChild(labelEl);

  if (shortcut) {
    const shortcutEl = document.createElement('span');
    shortcutEl.className = 'menu-item-shortcut';
    shortcutEl.textContent = shortcut;
    button.appendChild(shortcutEl);
  }
  button.addEventListener('click', () => {
    if (button.disabled) return;
    action();
    closeContextMenu();
  });
  menu.appendChild(button);
  return button;
}

export function closeContextMenu() {
  if (activeMenu) {
    activeMenu.remove();
    activeMenu = null;
  }
  setMobileContextExpanded(false);
}

export function hasActiveMenu() {
  return Boolean(activeMenu);
}

export function containsActiveMenuTarget(target) {
  return Boolean(activeMenu && activeMenu.contains(target));
}

export function getMobileAnchorPoint() {
  const fab = refs.mobileContextFab;
  if (!fab) {
    return { x: window.innerWidth - 180, y: window.innerHeight - 160 };
  }

  const rect = fab.getBoundingClientRect();
  return {
    x: rect.left - 148,
    y: rect.top - 116
  };
}
